import { SearchModel } from '../../search/search.model';

export class PartTypesSearchModel extends SearchModel {
  categoryId: string = '';
  subCategoryId: string = '';
  partTermId: string = '';
}
